import React from 'react';
import { useSelector } from 'react-redux';

import ViewWallet from './ViewWallet';
import store from '../../../store';

function ViewWalletContainer(props) {
  const walletContent = useSelector((state) => state.wallet.walletContent);
  const walletTotal = useSelector(store.select.wallet.walletTotal);
  return (
    <ViewWallet
      walletContent={walletContent}
      walletTotal={walletTotal}
      {...props}
    />
  );
}

export default ViewWalletContainer;
